import { SubscriptionSubjectType, SubscriptionType } from "../../../types/Student";
import { post } from "../../../utils/axios-config";
import { SUBSCRIPTIONS, SUBSCRIPTIONS_SUBJECTS } from "../../../utils/constants";

export const createSubscription = async (data: SubscriptionType) => await post<SubscriptionType, string>(SUBSCRIPTIONS, data);
export const createSubscriptionSubject = async (data: SubscriptionSubjectType) => await post<SubscriptionSubjectType, string>(SUBSCRIPTIONS_SUBJECTS, data);